
// let observer = new MutationObserver(function(mutationsList) {
//     let apElements = document.querySelector('.avpoptions-container__v2');
//     if (apElements) {
//         document.querySelectorAll('.avp-option.ap-options__radio-container input[type="radio"]').forEach(radio => {
//             radio.addEventListener('click', function() {
//                 this.checked = true; 
//             });
//         });
//     }
// });

// observer.observe(document.body, { childList: true, subtree: true });

(() => {
  const containers = '.avpoptions-container__v2';
  const blockedNames = new Set(['HD Lenses', 'Fog-Off']);
  const savedBlocks = new WeakMap();
  const savedInputs = new WeakMap();
  let scheduled = false;

  const toggleBlock = (block, blocked) => {
    if (blocked) {
      if (!savedBlocks.has(block)) {
        savedBlocks.set(block, {
          hidden: block.hidden,
          display: block.style.getPropertyValue('display'),
          priority: block.style.getPropertyPriority('display'),
        });
      }
      if (!block.hidden) block.hidden = true;
      if (block.style.display !== 'none' || block.style.getPropertyPriority('display') !== 'important') {
        block.style.setProperty('display', 'none', 'important');
      }
    } else if (savedBlocks.has(block)) {
      const previous = savedBlocks.get(block);
      block.hidden = previous.hidden;
      if (previous.display) block.style.setProperty('display', previous.display, previous.priority);
      else block.style.removeProperty('display');
      savedBlocks.delete(block);
    }
  };

  const sync = () => {
    scheduled = false;
    document.querySelectorAll(containers).forEach((container) => {
      const section = container.closest('.js-product') || container.closest('main');
      if (!section) return;
      const choices = section.querySelectorAll('variant-picker input:checked, variant-picker select option:checked');
      const demo = Array.from(choices).some((choice) => /\bdemo lenses\b/i.test(choice.value));
      container.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        if (!blockedNames.has(input.getAttribute('field-name') || input.name)) return;
        const block = input.closest('.main-tab, .avp-option');
        if (!block) return;
        if (demo && input.checked) {
          // Let Aris clear its own selected add-on and price before disabling the control.
          const disabled = input.disabled;
          input.disabled = false;
          input.click();
          input.disabled = disabled;
        }
        block.querySelectorAll('input').forEach((field) => {
          if (demo) {
            if (!savedInputs.has(field)) savedInputs.set(field, field.disabled);
            if (!field.disabled) field.disabled = true;
          } else if (savedInputs.has(field)) {
            field.disabled = savedInputs.get(field);
            savedInputs.delete(field);
          }
        });
        toggleBlock(block, demo);
        const explanation = block.nextElementSibling;
        if (explanation?.matches('.ap-options__paragraph-container')) toggleBlock(explanation, demo);
      });
    });
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      queueMicrotask(sync);
    }
  };
  document.addEventListener('change', schedule, true);
  document.addEventListener('on:variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['checked', 'disabled', 'style'],
  });
  sync();
})();

